import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-6">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !last ? (
                <Link to={item.to} className="hover:text-primary-600 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={last ? 'text-foreground-800' : ''}>{item.label}</span>
              )}
              {!last && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}